import { NavLink } from 'react-router-dom';
import { Button, Typography } from 'seagull';
import { routes } from "../../constants";
import { useStore } from "../../contexts";
import { UserRole } from "../../models";
import { selectors } from "../../store/state-selectors";
import { ProposalsIllustration } from "../../pages/ProposalsDashboard/ProposalsIllustration";
import styles from "./CanceledProposalPage.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CanceledProposalPage() {
  const role = useStore(selectors.user.role);
  const showGoBackButton = role !== UserRole.Reviewer;
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    "data-testid": "canceled-proposal-page",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(ProposalsIllustration, {}), /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        className: styles.text,
        children: "Canceled proposal"
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.text,
        children: "Your service provider has canceled this proposal, and the link has changed. As soon as the service provider sends you a new proposal, you will receive an updated link."
      }), showGoBackButton && /*#__PURE__*/_jsx(NavLink, {
        to: routes.proposalsDashboard,
        children: /*#__PURE__*/_jsx(Button, {
          skin: "primary",
          className: styles.button,
          testId: "canceled-proposal-go-back",
          children: "Go back to Anchor"
        })
      })]
    })
  });
}